import React from 'react';
import LazyLoad from 'react-lazyload';
import styled from 'styled-components';
import MediaPreloader from '@com/core/common/components/mediaPreloader';

const VideoModuleContainer = styled.div`
    video {
        display: block;
    }
`;

type TProps = {
    moduleData: {
        videoUrl: string;
        ratio: number;
        posterUrl: string;
    };
};

const VideoModule = ({ moduleData }: TProps): JSX.Element => {
    return (
        <VideoModuleContainer>
            <LazyLoad once offset={300}>
                <MediaPreloader ratio={moduleData.ratio}>
                    <video controls poster={moduleData.posterUrl}>
                        <track default kind="captions" />
                        <source src={moduleData.videoUrl} type="video/mp4" />
                        <img src={moduleData.posterUrl} alt="videoModule" />
                    </video>
                </MediaPreloader>
            </LazyLoad>
        </VideoModuleContainer>
    );
};

export default VideoModule;
